import React from 'react';
import { Shield } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-navy text-slate-400 py-8 md:py-12 border-t border-brand-blue" data-id="element-87">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-88">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 md:gap-6" data-id="element-89">
          <div className="flex items-center gap-3" data-id="element-90">
            <Shield className="w-6 h-6 md:w-8 md:h-8 text-brand-gold" data-id="element-91" />
            <div data-id="element-92">
              <div className="text-white font-serif font-bold text-base md:text-lg" data-id="element-93">
                PROTOCOLO INTEGRAL
              </div>
              <div className="text-[10px] md:text-xs tracking-wider uppercase" data-id="element-94">
                Del Consultorio Dermatológico™
              </div>
            </div>
          </div>

          <div className="text-center md:text-right text-xs md:text-sm" data-id="element-95">
            <p className="mb-1 md:mb-2" data-id="element-96">
              El sistema de protocolos N°1 para dermatólogos en Argentina.
            </p>
            <p className="text-slate-500" data-id="element-97">
              contacto@solucionesya.shop | @solucionesya.shop
            </p>
          </div>
        </div>

        <div className="mt-8 pt-6 md:mt-12 md:pt-8 border-t border-brand-blue/50 text-center text-[10px] md:text-xs text-slate-500" data-id="element-98">
          © Solucionesya.shop 2026 — Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}